module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback5-ed58cd709767f4458d3e39f773bca7cd.jpg";